import { hotelServiceInstance } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        hotelListData: [],
        hotelCommissions: [],
    },
    mutations: {
        SET_HOTEL_LIST(state, hotelList) {
            state.hotelListData = hotelList;
        },
        SET_HOTEL_COMMISSIONS(state, commissions) {
            state.hotelCommissions = commissions;
        },
        UPDATE_HOTEL_STATUS(state, { hotel_id, is_active }) {
            const hotel = state.hotelListData.find(h => h.hotel_id === hotel_id);
            if (hotel) {
                hotel.is_active = is_active;
            }
        },
        ADD_HOTEL(state, hotel) {
            state.hotelListData.push(hotel);
        },
        UPDATE_HOTEL_INFO(state, updatedHotel) {
            const index = state.hotelListData.findIndex(h => h.hotel_id === updatedHotel.hotel_id);
            if (index !== -1) {
                Object.assign(state.hotelListData[index], updatedHotel);
            }
        },
        UPDATE_HOTEL_LOCATION(state, { hotel_id, location }) {
            const hotel = state.hotelListData.find(h => h.hotel_id === hotel_id);
            if (hotel) {
                const locIndex = hotel.locations.findIndex(l => l.location_id === location.location_id);
                if (locIndex !== -1) {
                    hotel.locations.splice(locIndex, 1, location);
                }
            }
        },
        UPDATE_APP_STYLE(state, { hotel_id, app_style }) {
            const hotel = state.hotelListData.find(h => h.hotel_id === hotel_id);
            if (hotel) {
                hotel.app_style = app_style;
            }
        },
    },
    actions: {
        async fetchHotelList({ commit }) {
            try {
                const response = await hotelServiceInstance.get("/api/v1/hotels");
                commit("SET_HOTEL_LIST", response);
                return response;
            } catch (error) {
                return;
            }
        },
        async fetchHotelCommissions({ commit }, hotel_id) {
            try {
                const response = await hotelServiceInstance.get(`/api/v1/hotel-comissions?hotel_id=${hotel_id}`);
                commit("SET_HOTEL_COMMISSIONS", response.commissions);
                return response;
            } catch (error) {
                return;
            }
        },
        async updateHotelStatus({ commit }, { hotel_id, is_active }) {
            try {
                const response = await hotelServiceInstance.patch(`/api/v1/hotels/${hotel_id}/status`, { is_active });
                commit("UPDATE_HOTEL_STATUS", { hotel_id, is_active });
                return response;
            } catch (error) {
                return;
            }
        },
        async createHotel({ commit }, hotelData) {
            try {
                const response = await hotelServiceInstance.post("/api/v1/hotels", hotelData);
                commit("ADD_HOTEL", response.hotel);
                return response;
            } catch (error) {
                return;
            }
        },
        async updateHotelInfo({ commit }, hotelData) {
            try {
                const response = await hotelServiceInstance.put(`/api/v1/hotels/${hotelData.hotel_id}`, hotelData);
                commit("UPDATE_HOTEL_INFO", response.hotel);
                return response;
            } catch (error) {
                return;
            }
        },
        async updateHotelLocation({ commit }, locationData) {
            try {
                const response = await hotelServiceInstance.put(`/api/v1/hotels/locations/${locationData.location_id}`, locationData);
                commit("UPDATE_HOTEL_LOCATION", { hotel_id: locationData.hotel_id, location: response.location });
                return response;
            } catch (error) {
                return;
            }
        },
        async updateAppStyle({ commit }, appStyleData) {
            try {
                const response = await hotelServiceInstance.put(`/api/v1/app-style/by-hotel-id/${appStyleData.hotel_id}`, appStyleData);
                commit("UPDATE_APP_STYLE", { hotel_id: appStyleData.hotel_id, app_style: response.app_style });
                return response;
            } catch (error) {
                return;
            }
        },
        async createHotelCommissions({ commit }, commissionsData) {
            try {
                const response = await hotelServiceInstance.post("/api/v1/hotel-comissions", commissionsData);
                return response.newCommissions;
            } catch (error) {
                return;
            }
        },
        async updateHotelCommission({ commit }, commissionData) {
            try {
                const response = await hotelServiceInstance.put(`/api/v1/hotel-comissions/${commissionData.id}`, commissionData);
                return response.updatedCommission;
            } catch (error) {
                return;
            }
        },
    },
    getters: {
        hotelListData: (state) => state.hotelListData,
        hotelCommissions: (state) => state.hotelCommissions,
    },
};
